import { Pipe, PipeTransform } from '@angular/core';
import { CallTypeCode } from '../models/call-type-code';

const CALL_TYPE_CODE_SET = new Set<string>(Object.values(CallTypeCode));

export function isCallTypeCode(value: string): value is CallTypeCode {
  return CALL_TYPE_CODE_SET.has(value);
}

@Pipe({
  name: 'callTypeCode',
  pure: true,
  standalone: false,
})
export class CallTypeCodePipe implements PipeTransform {
  transform(code?: string): string {
    if (!code) {
      return '';
    }
    if (!isCallTypeCode(code)) {
      return 'tkey;reports.microsoft.pstn_call_record_finder.table.call_type_code.unknown';
    }
    return `tkey;reports.microsoft.pstn_call_record_finder.table.call_type_code.${code.toLowerCase()}`;
  }
}
